"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

/**
 * Link
 *
 * @param {string} label
 * @param {string} className
 * @param {string} to - Link to route
 */
var Link =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Link, _Component);

  function Link() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Link);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Link)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.childrenFragment = function (labelElement, children) {
      if (children) {
        return children;
      } else {
        return labelElement;
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(Link, [{
    key: "render",
    value: function render() {
      if (this.props.external) {
        return _react["default"].createElement("a", (0, _extends2["default"])({
          href: this.props.to,
          style: this.props.style,
          className: this.props.className,
          target: this.props.target || '_blank'
        }, (0, _taggingHelper.getDataProperty)({
          dataElementType: _taggingHelper.DataElementTypes.LINK,
          dataElementLocation: this.props.dataElementLocation,
          dataElementLabel: this.props.dataElementLabel,
          dataElementId: this.props.dataElementId
        })), this.childrenFragment(this.props.label, this.props.children));
      }

      return _react["default"].createElement(_reactRouterDom.Link, (0, _extends2["default"])({
        to: this.props.to,
        title: this.props.titleTag,
        className: this.props.className,
        onClick: this.props.onClick,
        style: this.props.style,
        target: this.props.target,
        tabIndex: this.props.tabIndex
      }, (0, _taggingHelper.getDataProperty)({
        dataElementType: _taggingHelper.DataElementTypes.LINK,
        dataElementLocation: this.props.dataElementLocation,
        dataElementLabel: this.props.dataElementLabel,
        dataElementId: this.props.dataElementId
      })), this.childrenFragment(this.props.label, this.props.children));
    }
  }]);
  return Link;
}(_react.Component);

Link.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  titleTag: _propTypes["default"].string,
  className: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),
  to: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  style: _propTypes["default"].object,
  target: _propTypes["default"].string,
  tabIndex: _propTypes["default"].number,
  external: _propTypes["default"].bool,
  dataElementLocation: _propTypes["default"].oneOf(_taggingHelper.DataElementLocationsArray).isRequired,
  dataElementLabel: _propTypes["default"].string.isRequired,
  dataElementId: _propTypes["default"].string.isRequired
};
Link.defaultProps = {
  activeOnlyWhenExact: false,
  label: ''
};
var _default = Link;
exports["default"] = _default;